<template>
    <div>
        <div
            v-if="banner == 'first' && advertising"
            class="tx-center px-4 py-10 md:py-15 mb-10 overflow-hidden"
        >
            <p
                class="tx-28 sm:tx-34 xl:tx-40 tx-dark-ad weight-700 m-0 wow t-bounceIn"
                data-wow-delay="0.4s"
            >
                Encuentra tu seminuevo o demo de agencia en un sólo lugar
            </p>
        </div>
        <div
            v-else-if="banner == 'second' && advertising"
            class="main__wrapper container bg-agency bg-center bg-no-repeat bg-cover w-full flex align-items-center mb-15 xl:mb-25 py-8 md:py-0"
            style="background-image: url('/assets/images/pages/home/advertising/Confianza.jpg');"
        >
            <p
                class="px-8 tx-28 sm:tx-34 xl:tx-40 tx-white-ad weight-700 m-0 wow t-bounceIn text-center"
                data-wow-delay="0.4s"
            >
                La forma más fácil de encontrar tu próximo auto seminuevo o demo de agencia.
            </p>
        </div>
        <!-- <div class="tx-center px-4 py-10 md:py-15 mb-10 overflow-hidden">
            <p
                class="tx-28 sm:tx-34 xl:tx-40 tx-dark-ad-1 weight-700 m-0 wow t-bounceIn"
                data-wow-delay="0.4s"
            >
                Especializados en re-posicionar la experiencia en el proceso de
                compra
            </p>
        </div> -->
    </div>
    <!-- <div v-if="banner == 'first' && advertising" class="flex justify-content-center align-items-center mb-15 xl:mb-9">
        <a class="box box--white" :href="'/ad/' + advertising.campaign_random.code + '?view=' + advertising.campaign_random.last_ad_view.id" target="_blank">
            <img :style="';width:'+advertising.width+'px;'" :src="advertising.campaign_random.image" :alt="advertising.title">
        </a>
    </div>

    <div v-else-if="banner == 'second' && advertising" class="flex justify-content-center align-items-center mb-18 md:mb-38">
        <a class="box box--white" :href="'/ad/' + advertising.campaign_random.code + '?view=' + advertising.campaign_random.last_ad_view.id" target="_blank">
            <img :src="advertising.campaign_random.image" :style="'width:'+advertising.width+'px;'" :alt="advertising.title">
        </a>
    </div> -->
</template>

<script>
export default {
    props: ["banner"],

    data() {
        return {
            advertising: null,

            formData: null,
            err: {}
        };
    },

    beforeMount() {
        let vm = this;
        vm.getCarTypesAsync();
    },

    methods: {
        async getCarTypesAsync(position) {
            let vm = this;

            try {
                let { data } = await axios.get(
                    "/client/home/home-advertisings/" + vm.banner
                );
                vm.advertising = data;
            } catch (error) {}
        },

        showErrors(error = null) {
            let vm = this;
            if (error) {
                vm.err = error.response.data;
            }
            vm.$swal({
                icon: "error",
                title: "Error",
                text: vm.err.message
                    ? vm.err.message
                    : "Se encontraron algunos errores en el formulario"
            });
        },

        resetForms() {
            let vm = this;
            vm.formData = new FormData();
            vm.err = [];
        }
    }
};
</script>
